import {
  CheckCircleTwoTone,
  SafetyCertificateTwoTone,
  TrophyTwoTone,
} from "@ant-design/icons";
import { Card, Col, Flex, Row, Typography } from "antd";
import { WE_ARE_SECTION } from "../../../constants/AppConstants";

import "./WeAre.css";

const { Title, Paragraph } = Typography;

const features = [
  {
    icon: (
      <SafetyCertificateTwoTone
        twoToneColor="#1890ff"
        style={{ fontSize: "42px" }}
      />
    ),
    title: "Premios Seguros",
  },
  {
    icon: <TrophyTwoTone twoToneColor="#faad14" style={{ fontSize: "42px" }} />,
    title: "Ganadores Mensuales",
  },
  {
    icon: (
      <CheckCircleTwoTone twoToneColor="#52c41a" style={{ fontSize: "42px" }} />
    ),
    title: "Confianza y Transparencia",
  },
];

export default function WeAre2() {
  return (
    <Flex className="weare-container my-80">
      <Title style={{ marginTop: "0" }} strong>
        {WE_ARE_SECTION.TITLE}
      </Title>
      <Paragraph style={{ fontSize: "16px" }}>
        {WE_ARE_SECTION.DESCRIPTION_1}
      </Paragraph>
      <Paragraph style={{ fontSize: "16px", marginBottom: "3em" }}>
        {WE_ARE_SECTION.DESCRIPTION_2}
      </Paragraph>
      <Row gutter={[16, 16]} justify="center">
        {features.map((item, index) => (
          <Col xs={24} sm={12} md={8} key={index}>
            <Card className="weare-feature-card" variant={false}>
              {item.icon}
              <Title level={5}>{item.title}</Title>
            </Card>
          </Col>
        ))}
      </Row>
    </Flex>
  );
}
